import Nullstack from 'nullstack';
export default function IconAbacusOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-abacus-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 5v16"
  }), "   ", Nullstack.element("path", {
    d: "M19 21v-2m0 -4v-12"
  }), "   ", Nullstack.element("path", {
    d: "M5 7h2m4 0h8"
  }), "   ", Nullstack.element("path", {
    d: "M5 15h10"
  }), "   ", Nullstack.element("path", {
    d: "M8 13v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 13v4"
  }), "   ", Nullstack.element("path", {
    d: "M16 16v1"
  }), "   ", Nullstack.element("path", {
    d: "M14 5v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 5v2"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v1"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h18"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}